/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IAssignClaimSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.AssignClaimWorkflowBlock;
        isReadonly: boolean;
        processConfigId: string;

        processClaims: Wars.Domain.Model.ClaimDefinition[];

        userTreeItem: Wars.Domain.Model.TreeItem;

        onDragOver($event: any): void;
        onDrop($event: any): void;

        getTreeItemDisplay(treeItem: Wars.Domain.Model.TreeItem): string;

        save(): void;
        cancel(): void;
    }

    export class AssignClaimSettingsModalController extends BaseModalController {
        scope: IAssignClaimSettingsModalControllerScope;

        constructor(
            $scope: IAssignClaimSettingsModalControllerScope,
            workflowBlock: models.AssignClaimWorkflowBlock,
            processConfigId: string,
            private workflowService: services.WorkflowService,
            private treeService: services.TreeService,
            private treeItemService: services.TreeItemService,
            private claimDefinitionService: services.ClaimDefinitionService,
            isReadonly: boolean,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;

            this.scope.onDragOver = ($event: any) => this.onDragOver($event);
            this.scope.onDrop = ($event: any) => this.onDrop($event);
            this.scope.getTreeItemDisplay = (treeItem: Wars.Domain.Model.TreeItem) => this.getTreeItemDisplay(treeItem);

            this.scope.save = () => this.save();
            this.scope.cancel = () => this.cancel();

            if (this.scope.workflowBlock.assignClaimDto) {
                if (this.scope.workflowBlock.assignClaimDto.otherUserTreeItem_id) {
                    this.treeItemService.getTreeItem(this.scope.workflowBlock.assignClaimDto.otherUserTreeItem_id)
                        .then((treeItem) => {
                            this.scope.userTreeItem = treeItem;
                        });
                }
            }

            this.claimDefinitionService.getAllProcessClaims(this.scope.processConfigId).then((processClaims) => {
                this.scope.processClaims = processClaims;
            });
        }

        private save(): void {
            // Save all tree item changes that are handled via breeze before trying to save workflow block changes which are all non-breeze
            this.treeItemService.saveAllChanges( () => {
                this.dismissModal(true);
            });
        }

        private cancel(): void {
            this.treeItemService.rejectChanges();
            this.dismissModal(false);
        }

        private getTreeItemDisplay(treeItem: Wars.Domain.Model.TreeItem): string {
            if (treeItem) {
                return this.treeService.getDisplayName(treeItem) + " of " + this.treeService.getParentDisplayName(treeItem);
            }
            return "";
        }

        private onDragOver($event: any): void {

        }

        private onDrop($event: any): void {
            var treeConfigItem = this.treeService.getTreeConfigurationItem();
            if (treeConfigItem.variableType !== Wars.Domain.Model.Codes.Enums.VariableType.User) {
                alert("Only User Tree Items are allowed for this drop zone.");
                return;
            }

            var treeItem = this.treeService.createTreeItemFromItemDropped();

            this.scope.userTreeItem = treeItem;
            this.scope.workflowBlock.assignClaimDto.otherUserTreeItem_id = treeItem.id;

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
        }
    }
}

warsApp.registerController('AssignClaimSettingsModalController',
    ['$scope', 'workflowBlock', 'processConfigId', "workflowService", "treeService", "treeItemService", "claimDefinitionService", 'isReadonly', 'close']);